import "shared/flash-notifications"
import "shared/haya-select"
import {PortalHost, PortalProvider} from "conjointment"
import {callbacksHandler} from "on-location-changed/build/callbacks-handler"
import {createRoot} from "react-dom/client"
import env from "shared/env"
import {Container as FlashNotifications} from "flash-notifications"
import history from "@kaspernj/api-maker/build/history"
import {LoadingBlocker} from "components/layout/loading-blocker"
import ModelsResponseReader from "@kaspernj/api-maker/build/models-response-reader"
import OutsideEyeProvider from "outside-eye/build/provider"
import ProductFruits from "./product-fruits"
import React from "react"
import SessionStatusUpdater from "@kaspernj/api-maker/build/session-status-updater"
import {StyleSheet} from "react-native"
import {WithCurrentUser} from "@kaspernj/api-maker/build/use-current-user"
import {WithDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"
import WithLocationPath from "on-location-changed/build/with-location-path"
import WoofRouter from "shared/woof-router"

require("shared/devise")

// Set global.applicationHistory so that on-location-changed will listen on it
callbacksHandler.connectReactRouterHistory(history)

if (window.currentUserData) {
  const modelsResponseReader = new ModelsResponseReader({response: window.currentUserData})
  const models = modelsResponseReader.models()

  window.currentUser = models[0]
}

globalThis.sessionStatusUpdater = new SessionStatusUpdater()
globalThis.sessionStatusUpdater.startTimeout()

const styles = StyleSheet.create({
  textDefault: {
    fontFamily: "HankenGrotesk"
  }
})

const defaultStyle = {
  Text: [styles.textDefault]
}

document.addEventListener("DOMContentLoaded", () => {
  const reactRoot = document.querySelector(".react-root")
  const root = createRoot(reactRoot)

  root.render(
    <OutsideEyeProvider>
      <WithCurrentUser>
        <WithDefaultStyle style={defaultStyle}>
          <WithLocationPath>
            <PortalProvider>
              <PortalHost placement="below">
                <LoadingBlocker />
                <WoofRouter />
                <FlashNotifications />
                {env.PRODUCTFRUIT_CODE &&
                  <ProductFruits />
                }
              </PortalHost>
            </PortalProvider>
          </WithLocationPath>
        </WithDefaultStyle>
      </WithCurrentUser>
    </OutsideEyeProvider>
  )
})
